"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.downloadCsv = void 0;
/**
 * Reusable utility function for generating and downloading CSV files.
 *
 * @param data - Array of records to be exported. Each record is an object.
 * @param headersToAttributes - A map linking CSV headers to the corresponding attribute keys in the data records.
 * @param fileName - The name of the generated CSV file.
 * @returns void
 *
 * This function takes an array of data records and a mapping of headers to attributes to generate a CSV file.
 * The generated CSV will have headers as specified in the `headersToAttributes` object.
 * The attributes in each data record are mapped to these headers based on the same object.
 * The resulting CSV file will be triggered for download with the given fileName.
 *
 * Example usage:
 * downloadCsv({
 *   data: [{type: 'Type1', amount: 100}, {type: 'Type2', amount: 200}],
 *   headersToAttributes: { 'Type': 'type', 'Amount': 'amount' },
 *   fileName: 'Data.csv',
 * });
 */
const downloadCsv = ({ data, headersToAttributes, fileName, }) => {
    const headers = Object.keys(headersToAttributes);
    const dataAttributes = Object.values(headersToAttributes);
    const csvData = [headers];
    data.forEach((record) => {
        const row = dataAttributes.map((attribute) => {
            const cellValue = record[attribute];
            if (!cellValue) {
                return "";
            }
            else if (String(cellValue).includes(",")) {
                return `"${cellValue}"`;
            }
            return cellValue;
        });
        csvData.push(row);
    });
    const csvString = csvData.map((row) => row.join(",")).join("\n");
    const csvBlob = new Blob([csvString], { type: "text/csv" });
    const url = window.URL.createObjectURL(csvBlob);
    const downloadLink = document.createElement("a");
    downloadLink.style.display = "none";
    downloadLink.href = url;
    downloadLink.download = fileName;
    document.body.appendChild(downloadLink);
    downloadLink.click();
    window.URL.revokeObjectURL(url);
    document.body.removeChild(downloadLink);
};
exports.downloadCsv = downloadCsv;
